export default function CVariablesExamples() {
  return <h2>C Variables Examples</h2>;
}
